
import { Vue, Component, Model, Watch, Prop } from 'vue-property-decorator';

@Component
export default class UseTofield extends Vue {
  val: any = '';

  useTofieldOptions = [
    { value: 1, label: '家用' },
    { value: 2, label: '营转非' },
    { value: 3, label: '单位用' },
  ];

  @Prop()
  readonly!: boolean;

  @Prop()
  placeholder!: string;


  getLabel(arr: any, val: any) {
    let _text = '';
    arr.forEach((res: any) => {
      if (res.value === val) {
        _text = res.label;
      }
    });
    return _text;
  }

  @Prop()
  disabled!: boolean;

  @Watch('val')
  changeVal() {
    this.$emit('change', this.val);
  }

  @Model('change')
  value!: any;


  // changeColor(val: string) {
  //   this.val = val;
  // }


  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = Number(this.value);
    } else {
      this.val = undefined;
    }
  }

  breakDown(val: any) {
    const _a: any = [];
    Object.keys(val).forEach((key) => {
      _a.push({
        value: Number(key),
        label: val[key],
      });
    });
    return _a;
  }

  mounted() {
    const carFields = JSON.parse(localStorage.getItem('carFields') || '{}');
    const { use_to } = carFields;
    this.useTofieldOptions = this.breakDown(use_to);
    this.watchValue();
  }
}
